import { CmsFrontComponent } from './views/cms/cms-front/cms-front.component';
import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';

// Import Containers
import { DefaultLayoutComponent } from './containers';

import { P403Component } from './views/error/403.component';
import { P404Component } from './views/error/404.component';
import { P500Component } from './views/error/500.component';
import { LoginComponent } from './views/login/login.component';
import { RegisterComponent } from './views/register/register.component';
import { ResetPasswordComponent } from './views/reset-password/reset-password.component';

import { AuthGuard } from './_guards/auth.guard';
import { AccountActivateComponent } from './views/account-activate/account-activate.component';
import {AccountActiveTempComponent} from './views/account-active-temp/account-active-temp.component';

import { VerifyOTPComponent } from './views/verify-otp/verify-otp.component';

export const routes: Routes = [
  {
    path: 'content/:slug',
    component: CmsFrontComponent,
    data: {
      title: 'Content Management Page'
    }
  },
  {
    path: '',
    redirectTo: 'dashboard',
    pathMatch: 'full',
  },
  {
    path: '404',
    component: P404Component,
    data: {
      title: 'Page 404'
    }
  },
  {
    path: '403',
    component: P403Component,
    data: {
      title: 'Page 403'
    }
  },
  {
    path: '500',
    component: P500Component,
    data: {
      title: 'Page 500'
    }
  },
  {
    path: 'login',
    component: LoginComponent,
    data: {
      title: 'Login Page'
    }
  },
  {
    path: 'verifyemail/:token',
    component: AccountActivateComponent,
    data: {
      title: 'Verify Email Page'
    }
  },
  {
    path: 'verifyemailtemp/:token',
    component: AccountActiveTempComponent,
    data: {
      title: 'Verify Email Page'
    }
  },

  {
    path: 'verifyotp',
    component: VerifyOTPComponent,
    data: {
      title: 'Verify OTP'
    }
  },
  {
    path: 'password/reset',
    component: ResetPasswordComponent,
    data: {
      title: 'Reset Password Page'
    }
  },
  {
    path: 'register',
    component: RegisterComponent,
    data: {
      title: 'Register Page'
    }
  },
  {
    path: '',
    component: DefaultLayoutComponent,
    canActivate: [AuthGuard],
    data: {
      title: 'Home'
    },
    children: [
      {
        path: 'base',
        loadChildren: () => import('./views/base/base.module').then(m => m.BaseModule)
      },
      
      {
        path: 'buttons',
        loadChildren: () => import('./views/buttons/buttons.module').then(m => m.ButtonsModule)
      },
      {
        path: 'charts',
        loadChildren: () => import('./views/chartjs/chartjs.module').then(m => m.ChartJSModule)
      },
      {
        path: 'dashboard',
        loadChildren: () => import('./views/dashboard/dashboard.module').then(m => m.DashboardModule),
        canActivateChild: [AuthGuard]
      },
      {
        path: 'subadmin',
        loadChildren: () => import('./views/manage-subadmin/subadmin.module').then(m => m.SubadminModule),
        canActivateChild: [AuthGuard]
      },
      // {
      //   path: 'manage-user',
      //   loadChildren: () => import('./views/manage-user/manage-user.module').then(m => m.ManageUserModule),
      //   canActivateChild: [AuthGuard]
      // },
      {
        path: 'icons',
        loadChildren: () => import('./views/icons/icons.module').then(m => m.IconsModule)
      },
      {
        path: 'notifications',
        loadChildren: () => import('./views/notifications/notifications.module').then(m => m.NotificationsModule)
      },
      {
        path: 'theme',
        loadChildren: () => import('./views/theme/theme.module').then(m => m.ThemeModule)
      },
      {
        path: 'widgets',
        loadChildren: () => import('./views/widgets/widgets.module').then(m => m.WidgetsModule)
      },
      {
        path: 'profile',
        loadChildren: () => import('./views/profile/profile.module').then(m => m.ProfileModule),
        canActivate: [AuthGuard]
      },
      {
        path: 'cms',
        loadChildren: () => import('./views/cms/cms.module').then(m => m.CmsModule),
        canActivateChild: [AuthGuard]
      },
      {
        path: 'email',
        loadChildren: () => import('./views/email-template/email.module').then(m => m.EmailModule),
        canActivateChild: [AuthGuard]
      },
      {
        path: 'faq',
        loadChildren: () => import('./views/faq/faq.module').then(m => m.FaqModule),
        canActivateChild: [AuthGuard]
      },
      {
        path: 'medicines-inventory-management',
        loadChildren: () => import('./views/manage-category/category.module').then(m => m.CategoryModule),
        canActivateChild: [AuthGuard]
      },
      {
        path: 'video-upload',
        loadChildren: () => import('./views/video-upload/video-upload.module').then(m => m.VideoUploadModule),
        canActivateChild: [AuthGuard]
      },
      {
        path: 'role-permissions',
        loadChildren: () => import('./views/role-permission/role-permission.module').then(m => m.RolePermissionModule),
        canActivateChild: [AuthGuard]
      },
      {
        path: 'manage-contact',
        loadChildren: () => import('./views/manage-contact/manage-contact.module').then(m => m.ManageContactModule),
        canActivateChild: [AuthGuard]
      },
      {
        path: 'settings',
        loadChildren: () => import('./views/settings/settings.module').then(m => m.SettingsModule),
        canActivateChild: [AuthGuard]
      },
      {
        path: 'symptoms-management',
        loadChildren: () => import('./views/symptoms-management/symptoms-management.module').then(m => m.SymptomsManagementModule),
        canActivateChild: [AuthGuard]
      },
      {
        path: 'specialization-management',
        loadChildren: () => import('./views/specialization-management/specialization-management.module')
                            .then(m => m.SpecializationManagementModule),
        canActivateChild: [AuthGuard]
      },
      {
        path: 'city-management',
        loadChildren: () => import('./views/city-management/city-management.module')
                            .then(m => m.CityManagementModule),
        canActivateChild: [AuthGuard]
      },
      // {
      //   path: 'disease-management',
      //   loadChildren: () => import('./views/diseases-management/diseases-management.module')
      //                       .then(m => m.DiseasesManagementModule),
      //   canActivateChild: [AuthGuard]
      // },
      {
        path: 'doctor-management',
        loadChildren: () => import('./views/doctor-management/doctor-management.module')
                            .then(m => m.DoctorManagementModule),
        canActivateChild: [AuthGuard]
      },
      {
        path: 'patient-management',
        loadChildren: () => import('./views/patient-management/patient-management.module')
                            .then(m => m.PatientManagementModule),
        canActivateChild: [AuthGuard]
      },
      {
        path: 'pharmacy-management',
        loadChildren: () => import('./views/pharmacy-management/pharmacy-management.module')
                            .then(m => m.PharmacyManagementModule),
        canActivateChild: [AuthGuard]
      },
      {
        path: 'doctors-consultations',
        loadChildren: () => import('./views/doctors-consultations/doctors-consultations.module')
                            .then(m => m.DoctorsConsultationsModule),
        canActivateChild: [AuthGuard]
      },
      {
        path: 'order-management',
        loadChildren: () => import('./views/order-management/order-management.module')
                            .then(m => m.OrderManagementModule),
        canActivateChild: [AuthGuard]
      },
      {
        path: 'review',
        loadChildren: () => import('./views/review/review.module')
                            .then(m => m.ReviewModule),
        canActivateChild: [AuthGuard]
      },
      {
        path: 'reward-management',
        loadChildren: () => import('./views/reward-management/reward-management.module')
                            .then(m => m.RewardManagementModule),
        canActivateChild: [AuthGuard]
      },
      {
        path: 'referral-management',
        loadChildren: () => import('./views/referral-management/referral-management.module')
                            .then(m => m.ReferralManagementModule),
        canActivateChild: [AuthGuard]
      },
      {
        path: 'user-report',
        loadChildren: () => import('./views/user-report/user-report.module')
                            .then(m => m.UserReportModule),
        canActivateChild: [AuthGuard]
      },
      {
        path: 'master-logs',
        loadChildren: () => import('./views/master-logs/master-logs.module')
                            .then(m => m.MasterLogsModule),
        canActivateChild: [AuthGuard]
      },

     {
        path: 'purchase-orders',
        loadChildren: () => import('./views/purchase-orders/purchase-order.module')
                            .then(m => m.PurchaseOrderModule),
        canActivateChild: [AuthGuard]
      },

      {
        path: 'supplier-management',
        loadChildren: () => import('./views/supplier-management/supplier-management.module')
                            .then(m => m.SupplierManagementModule),
        canActivateChild: [AuthGuard]
      },

      {
        path: 'hospital-management',
        loadChildren: () => import('./views/hospital-management/hospital-management.module')
                            .then(m => m.HospitalManagementModule),
        canActivateChild: [AuthGuard]
      },

      {
        path: 'inquiry-management', 
        loadChildren: () => import('./views/inquiry-management/inquiry-management-component.module')
                            .then(m => m.InquiryComponentModule),
        canActivateChild: [AuthGuard]
      },
      
      {
        path: 'appointment-management', 
        loadChildren: () => import('./views/appointment-management/appointment-management.module')
                            .then(m => m.AppointmentManagementModule),
        canActivateChild: [AuthGuard]
      },
      {
        path: 'notification-management', 
        
        loadChildren: () => import('./views/notification-management/notification-management.module').then(m => m.NotificationManagementModule),
        canActivateChild: [AuthGuard]
      },
      
      {
        path: 'billing-management', 
        loadChildren: () => import('./views/billing-management/billing.module')
                            .then(m => m.BillingModule),
        canActivateChild: [AuthGuard]
      },
      
      
      {
        path: 'ipd-management', 
        loadChildren: () => import('./views/ipd-management/ipd-management.module')
                            .then(m => m.IpdManagementModule),
        canActivateChild: [AuthGuard]
      },
      
      {
        path: 'labs-management', 
        loadChildren: () => import('./views/labs-management/labs-management.module')
                            .then(m => m.LabsManagementModule),
        canActivateChild: [AuthGuard]
      },
      
      {
        path: 'diagnostic-management', 
        loadChildren: () => import('./views/diagnostic-management/diagnostic-management.module')
                            .then(m => m.DiagnosticManagementModule),
        canActivateChild: [AuthGuard]
      } ,
      {
      path: 'whatsapp-management',
      loadChildren: () => import('./views/whatsapp-management/whatsapp-management.module')
                      .then(m => m.WhatsappManagementModule),
      // canActivateChild: [AuthGuard]
      }

    ]
  },
  {
    path: '**',
    redirectTo: '404',
    pathMatch: 'full',
  }
];

@NgModule({
  imports: [RouterModule.forRoot(routes)],
  exports: [RouterModule]
})
export class AppRoutingModule { }
